// extracted by mini-css-extract-plugin
module.exports = {"rentalInfoWrapper":"d2","status":"d3","timeLeft":"d4"};